import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Close as CloseIcon,
  Smartphone as PhoneIcon,
  Tablet as TabletIcon,
  Laptop as DesktopIcon,
} from '@mui/icons-material';

function PreviewDialog({ open, onClose, title, content }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [viewportSize, setViewportSize] = React.useState('desktop');

  const getPreviewWidth = () => {
    switch (viewportSize) {
      case 'mobile':
        return '375px';
      case 'tablet':
        return '768px';
      default:
        return '100%';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      fullScreen={fullScreen}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          Preview: {title}
          <Box sx={{ display: 'inline-flex', ml: 2 }}>
            <IconButton
              size="small"
              onClick={() => setViewportSize('mobile')}
              color={viewportSize === 'mobile' ? 'primary' : 'default'}
            >
              <PhoneIcon />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => setViewportSize('tablet')}
              color={viewportSize === 'tablet' ? 'primary' : 'default'}
            >
              <TabletIcon />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => setViewportSize('desktop')}
              color={viewportSize === 'desktop' ? 'primary' : 'default'}
            >
              <DesktopIcon />
            </IconButton>
          </Box>
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            width: getPreviewWidth(),
            margin: '0 auto',
            transition: 'width 0.3s ease',
            bgcolor: 'background.paper',
            p: 3,
            borderRadius: 1,
            minHeight: '50vh',
            '& img': {
              maxWidth: '100%',
              height: 'auto',
            },
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default PreviewDialog; 